export const state = () => ({
  locale: 'en-GB',
})

export const mutations = {
  setLocale(state, locale) {
    state.locale = locale
  },
}

export const actions = {
  setLocaleToBrowser({ commit }) {
    if (process.browser) {
      const browserLocale = navigator.language || navigator.userLanguage
      const normalisedLocale = browserLocale.trim().replace(/_/g, '-')

      commit('setLocale', normalisedLocale)
    }
  },
}

export const getters = {
  locale(state) {
    return state.locale
  },
}

export const store = () => ({
  state,
  mutations,
  actions,
  getters,
})
